<template>
  <BaseQuery class="port-query" :loading="loading">
    <el-form
      slot="searchBox"
      ref="ruleForm"
      size="mini"
      label-position="right"
      :model="ruleForm"
      label-width="100px"
    >
      <div class="contentLeft">
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="账号">
              <el-input
                v-model="ruleForm.uname"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="结果">
              <el-select
                v-model="ruleForm.status"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in resultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="订阅时间">
              <el-date-picker
                v-model="ruleForm.ftime"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                placeholder="开始日期"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="——">
              <el-date-picker
                v-model="ruleForm.ltime"
                style="width: 100%"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="结束日期"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="提单号">
              <el-input
                v-model="ruleForm.bill"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="箱号">
              <el-input
                v-model="ruleForm.ctnr"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="港区代码">
              <el-input
                v-model="ruleForm.port"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>

          <el-col style="width: 22%">
            <el-form-item label="进出口标识">
              <el-select
                v-model="ruleForm.ieid"
                style="width: 100%"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in ieids"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="contenRight">
        <el-button size="small" class="serachBtn" @click="doExport2">
          导出
        </el-button>
        <el-button size="small" class="serachBtn" @click="search">
          搜索
        </el-button>
      </div>
      <div style="clear: both"></div>
    </el-form>
    <!--    <div class="buttonTop"></div>-->

    <el-table
      :header-cell-style="headerCellStyle"
      :data="data.results"
      height="550px"
      :row-key="rowKey"
    >
      <el-table-column
        prop="uname"
        label="账号"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />
      <el-table-column
        prop="bill"
        label="提单号"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />
      <el-table-column
        prop="ctnr"
        label="箱号"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />
      <el-table-column
        prop="carrier"
        label="船公司"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />
      <el-table-column
        prop="port"
        label="港口"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />
      <el-table-column
        prop="ieid"
        label="进出口标识"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />

      <el-table-column
        prop="subscribeTime"
        label="订阅时间"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="queryState"
        label="查询结果"
        show-overflow-tooltip
        align="left"
        min-width="80"
      >
        <template slot-scope="scope">
          {{ scope.row.queryState ? '有数据' : '无数据' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="pushTime"
        label="推送时间"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="cbTime"
        label="获取数据时间"
        show-overflow-tooltip
        align="left"
        min-width="150"
      >
        <template slot-scope="scope">
          {{
            scope.row.cbTime ||
              (scope.row.queryState ? scope.row.subscribeTime : '')
          }}
        </template>
      </el-table-column>

      <el-table-column
        prop="currentstatus"
        label="最新节点"
        show-overflow-tooltip
        align="left"
        min-width="80"
      >
        <template slot-scope="scope">
          {{ scope.row.currentstatus | node(scope.row.sysIeid) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="currenttime"
        label="最新节点时间"
        show-overflow-tooltip
        align="left"
        min-width="250"
      >
        <template slot-scope="scope">
          {{ scope.row.currenttime }}
          <span v-if="scope.row.diffHours !== undefined">
            ({{ scope.row.diffHours | diff }})
          </span>
        </template>
      </el-table-column>

      <el-table-column
        prop="pol"
        label="起始港"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />

      <el-table-column
        prop="pod"
        label="卸货港"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />

      <el-table-column
        prop="dtp"
        label="目的港"
        show-overflow-tooltip
        align="left"
        min-width="100"
      />

      <el-table-column
        prop="cyopentime"
        label="开港时间"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="cyclosetime"
        label="截港时间"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="eta"
        label="ETA"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="ata"
        label="ATA"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="etb"
        label="ETB"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="atb"
        label="ATB"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="etd"
        label="ETD"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="atd"
        label="ATD"
        show-overflow-tooltip
        align="left"
        min-width="150"
      />

      <el-table-column
        prop="gitm"
        label="进场"
        show-overflow-tooltip
        align="center"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ scope.row.gitm ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="pass"
        label="海放(出口)"
        show-overflow-tooltip
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sysIeid === 'E' && scope.row.pass ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="tmps"
        label="码放"
        show-overflow-tooltip
        align="center"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ scope.row.tmps ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="lobd"
        label="装船"
        show-overflow-tooltip
        align="center"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ scope.row.lobd ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="dsch"
        label="卸船"
        show-overflow-tooltip
        align="center"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ scope.row.dsch ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="pass"
        label="海放(进口)"
        show-overflow-tooltip
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sysIeid === 'I' && scope.row.pass ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        prop="stcs"
        label="提货"
        show-overflow-tooltip
        align="center"
        min-width="50"
      >
        <template slot-scope="scope">
          {{ scope.row.stcs ? '√' : '' }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        show-overflow-tooltip
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="scope.row.pushDisabled"
            @click="pushMessage(scope.row)"
          >
            立即推送
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :disabled="disabled" @next="next" @prev="prev" />
  </BaseQuery>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import Pagination from './Pagination'
import commonMixin, { handleCurrentTimeData } from './common.mixin'
import dayjs from 'dayjs'

export default {
  name: 'PortQuery',

  components: {
    BaseQuery,
    Pagination,
  },

  mixins: [commonMixin],

  data() {
    return {
      ruleForm: {
        uname: '',
        bill: '',
        ctnr: '',
        ftime: null,
        ltime: null,
        port: '',
        ieid: '',
        status: 0,
      },
      loading: false,
      data: {
        results: [],
        size: 50,
      },

      stack: [],
    }
  },

  computed: {
    ieids() {
      return [
        {
          label: '全部',
          value: '',
        },
        {
          label: '进口',
          value: 'I',
        },
        {
          label: '出口',
          value: 'E',
        },
      ]
    },

    disabled() {
      return {
        next: !this.data.size || this.data.results.length < this.data.size,
        prev: this.stack.length === 0,
      }
    },
  },

  methods: {
    rowKey(row) {
      return row.id
    },

    async doExport2() {
      this.loading = true

      const params = Object.assign({}, this.ruleForm)

      if (params.ltime) {
        params.ltime += ` 23:59:59.999`
      }

      try {
        await this.doExport('/schedules/traceOps/exportPort', params)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    async pushMessage(row) {
      const { uid, bill, ctnr, pushTime, reference } = row

      if (pushTime) {
        const minutes = Math.abs(
          dayjs(pushTime, 'YYYY-MM-DD HH:mm:ss').diff(new Date(), 'minutes')
        )
        if (minutes <= 10) {
          let message
          if (minutes === 0) {
            message = '刚刚'
          } else {
            message = `${minutes}分钟前`
          }
          try {
            await this.$confirm(`当前数据在${message}推送过,是否继续推送?`)
          } catch (e) {
            return
          }
        }
      }

      this.loading = true

      try {
        await this.doPush(bill, ctnr, uid)
        this.$message.success('推送成功')
        this.$set(row, 'pushDisabled', true)
        if (reference) {
          this.data.results.forEach(item => {
            if (item.reference === reference && item.uid === uid) {
              this.$set(item, 'pushDisabled', true)
            }
          })
        }
      } catch (e) {
        this.$message.success('推送失败')
      } finally {
        this.loading = false
      }
    },

    async doSearch(object) {
      this.loading = true
      let resp
      try {
        const params = Object.assign({}, this.ruleForm, object || {})

        if (params.ltime) {
          params.ltime += ` 23:59:59.999`
        }

        resp = await this.$axios.post(
          `${this.commonJs.localUrl}/schedules/traceOps/queryPort`,
          params,
          {
            headers: {
              authorization: `Bearer ${this.getAuthorization()}`,
            },
          }
        )

        if (resp) {
          if (resp.data.status === 1) {
            this.data.results = handleCurrentTimeData(resp.data.content.results)
            this.data.size = resp.data.content.query.size
            return true
          } else {
            this.$message.error(resp.data.message || '港区查询数据错误')
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },

    search() {
      this.data.results = []
      this.stack = []
      this.doSearch()
    },

    async next() {
      let maxId = this.data.results[0].id,
        minId = this.data.results[this.data.results.length - 1].id

      if (
        await this.doSearch({
          id: minId,
          action: 'next',
        })
      ) {
        this.stack.push({
          maxId,
          minId,
        })
      }
    },

    async prev() {
      const minId = this.stack[this.stack.length - 1].minId,
        maxId = this.data.results.length ? this.data.results[0].id : minId - 1

      if (
        await this.doSearch({
          id: maxId,
          action: 'prev',
        })
      ) {
        this.stack.pop()
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .demo-table-expand {
  font-size: 0;
}

::v-deep .demo-table-expand label {
  width: 250px;
  color: #99a9bf;
}

::v-deep .el-row .el-col:nth-last-of-type(1) {
  margin-right: 0;
}

::v-deep .el-col {
  margin-right: 20px;
}

::v-deep .refPagination input {
  width: 100px !important;
}

::v-deep .el-table__expand-icon {
  visibility: hidden !important;
}

::v-deep .el-table__expanded-cell {
  text-align: center !important;
  color: #3bafda;
}

::v-deep .el-table th,
.el-table tr {
  height: 30px;
}

::v-deep .el-table th {
  height: 30px;
  padding: 0;
}

::v-deep .el-scrollbar__view .el-select-dropdown__list li:nth-of-type(1) {
  color: #409eff;
  font-weight: 700;
}

::v-deep .el-table .warning-row {
  background: rgba(241, 245, 247, 1) !important;
}

.serachBtn {
  padding: 9px 35px;
  color: #fff;
  background-color: rgba(4, 153, 255, 1);
  margin-bottom: 10px;
  border: 1px solid #3bafda;
}

.contentLeft {
  float: left;
  width: 90%;
}

.contenRight {
  position: absolute;
  right: 20px;
  bottom: 5px;
}

label:nth-of-type(2) {
  width: 10px !important;
}

.buttonTop {
  margin-bottom: 20px;

  //.clickColor {
  //  background-color: #fff;
  //  padding: 9px 15px;
  //  margin-right: 10px;
  //}

  //.teshunormal {
  //  color: #3bafda;
  //  border: 1px solid #3bafda;
  //  width: 80px;
  //  cursor: pointer;
  //  background: #fff;
  //  text-align: center;
  //  margin-right: 20px;
  //}
}

::v-deep .el-table__empty-text {
  width: 100%;
}
</style>
